import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Arrow from '../../../../images/points-offer-arrow.svg';

export const TitleCopy = styled.h3``;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1rem;

  h3 {
    color: ${({ theme, headingColor }) =>
      headingColor ? theme.colors[headingColor] : null};
    font-size: 0.85rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1.2rem;
    }
  }

  &:after {
    content: '';
    background-image: url(${Arrow});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    height: 3rem;
    width: 4rem;
    right: 2rem;
    top: 1rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 5rem;
    }
  }
`;
